export default class EditorDataBase {
  constructor() {
    this.db = null;
    const request = window.indexedDB.open('EditorHistory', 1);
    // error事件表示打开数据库失败。
    request.onerror = () => {
      console.log('数据库打开报错');
    };

    request.onsuccess = () => {
      this.db = request.result; // 通过request对象的result属性拿到数据库对象
    };

    request.onupgradeneeded = event => {
      this.db = event.target.result; // 通过事件对象的target.result属性，拿到数据库实例。
      // let objectStore;
      if (!this.db.objectStoreNames.contains('history')) {
        // 新建对象仓库（即新建表）: 新增一张叫做 history 的表格，主键是 timestamp。
        this.db.createObjectStore('history', { keyPath: 'timestamp' });
      }
    };
  }

  add({ timestamp, name, content }) {
    const transaction = this.db.transaction(['history'], 'readwrite');
    // 通过 IDBTransaction.objectStore(name) 方法，拿到 IDBObjectStore 对象

    const objectStore = transaction.objectStore('history');
    // 通过表格对象的 add() 方法，向表格写入一条记录
    const request = objectStore.add({
      timestamp, name, content,
    });

    request.onsuccess = () => {
      const countRequest = objectStore.count();
      countRequest.onsuccess = () => {
        const historyLen = countRequest.result;
        // 若当前编辑器历史超过 100 条记录
        if (historyLen > 100) {
        //   // 删掉超过 100 条的记录
          const allRequest = objectStore.getAllKeys();

          allRequest.onsuccess = () => {
            const list = allRequest.result;
            this.delete(list[0]);
          };

          allRequest.onerror = e => {
            console.log('数据写入失败', e);
          };
        }
      };
      countRequest.onerror = countRes => {
        console.log('🚀 ~ file: dbTools.js ~ line 42 ~ EditorDataBase ~ add ~ countRes', countRes);
      };
    };

    request.onerror = event => {
      console.log('数据写入失败', event);
    };
  }

  get(timestamp) {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction(['history']);
      const objectStore = transaction.objectStore('history');
      const request = objectStore.get(timestamp);

      request.onerror = event => {
        console.log('事务失败', event);
        reject();
      };

      request.onsuccess = event => {
        if (request.result) {
          resolve(request.result);
        } else {
          console.log('未获得数据记录', event);
          reject();
        }
      };
    });
  }

  getAll() {
    return new Promise(resolve => {
      const transaction = this.db.transaction(['history']);
      const objectStore = transaction.objectStore('history');
      const request = objectStore.getAll();

      request.onsuccess = () => {
        resolve(request.result);
      };

      request.onerror = () => {
        resolve([]);
      };
    });
  }

  delete(timestamp) {
    return new Promise((resolve, reject) => {
      const request = this.db.transaction(['history'], 'readwrite')
        .objectStore('history')
        .delete(timestamp);

      request.onsuccess = () => {
        resolve();
      };
      request.onerror = () => {
        console.log('数据删除失败', request);
        reject();
      };
    });
  }

  clear() {
    return new Promise((resolve, reject) => {
      const request = this.db.transaction(['history'], 'readwrite')
        .objectStore('history')
        .clear();

      request.onsuccess = () => {
        resolve();
      };
      request.onerror = () => {
        console.log('清空失败', request);
        reject();
      };
    });
  }

  close() {
    return new Promise((resolve, reject) => {
      const request = this.db.close();

      request.onsuccess = () => {
        resolve();
      };
      request.onerror = () => {
        console.log('关闭数据库失败', request);
        reject();
      };
    });
  }
}
